export default "__VITE_ASSET__CBBYPOii__"